import angular from 'angular';
import ImageEventDirective from './image-event.directive';

const ImageEventModule = angular
    .module('control-room.commons.content.components.image-event', [])
    .directive('crImageEvent', ImageEventDirective.directiveFactory);

export default ImageEventModule;
